import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (!MEASUREMENT_ID) {
    return;
  }
  ReactGA.initialize(MEASUREMENT_ID, {
    gaOptions: {
      anonymize_ip: true, // Privacy: anonymize IP addresses
      cookie_flags: 'SameSite=None;Secure'
    }
  });
};

// Track page views
export const trackPageView = (path) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: document.title
  });
};

// Track custom events
export const trackEvent = (category, action, label = '', value = 0) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track profile interactions
export const trackProfileView = (profilePage) => {
  trackEvent('Navigation', 'Profile View', profilePage);
};

export const trackContactFormSubmit = () => {
  trackEvent('Engagement', 'Contact Form Submit', 'Contact Page');
};

export const trackButtonClick = (buttonName) => {
  trackEvent('Engagement', 'Button Click', buttonName);
};
